import { RouteRecordRaw } from 'vue-router';
import { AdminPermissionsPage } from '@/pages/admin';
import AdminPermissionsPermissionsPage from '@/pages/admin/ui/permissions/AdminPermissionsPermissionsPage.vue';
import AdminPermissionsListPage from '@/pages/admin/ui/permissions/AdminPermissionsListPage.vue';
import AdminPermissionsAssignmentsPage from '@/pages/admin/ui/permissions/AdminPermissionsAssignmentsPage.vue';

export const routeName = 'AdminPermissoes';

export const route: RouteRecordRaw = {
  path: 'permissoes',
  name: routeName,
  component: AdminPermissionsPage,
  redirect: '/admin/permissoes/permissoes',
  meta: {
    requiresAuth: true,
    breadcrumb: 'Permissões',
    permissions: [{ action: 'managePermissions', subject: 'Admin' }],
  },
  children: [
    {
      path: 'permissoes',
      name: 'AdminPermissoesPermissoes',
      component: AdminPermissionsPermissionsPage,
      meta: {
        requiresAuth: true,
        breadcrumb: 'Permissões',
        permissions: [{ action: 'managePermissions', subject: 'Admin' }],
      },
    },
    {
      path: 'listar',
      name: 'AdminPermissoesListar',
      component: AdminPermissionsListPage,
      meta: {
        requiresAuth: true,
        breadcrumb: 'Listar Permissões',
        permissions: [{ action: 'managePermissions', subject: 'Admin' }],
      },
    },
    {
      path: 'atribuicoes',
      name: 'AdminPermissoesAtribuicoes',
      component: AdminPermissionsAssignmentsPage,
      meta: {
        requiresAuth: true,
        breadcrumb: 'Atribuições',
        permissions: [{ action: 'managePermissions', subject: 'Admin' }],
      },
    },
  ],
};
